// extracted by mini-css-extract-plugin
export default {"small":"b3PiB0","large":"c3PiB0"};